import React, { createContext, useContext } from 'react';
import { useSelector } from 'react-redux';

import { isEverbridgeFlowDesignerApp } from 'selectors/featureToggles';
import { EBFD_HELP_URL, XMATTERS_HELP_URL } from 'xm-constants/urls';
import { helpLinks as ebfd } from 'helpLinks/ebfd';
import { helpLinks as xm } from 'helpLinks/xm';

export const HelpLinksContext = createContext({});

export const HelpLinksProvider = ({ children }) => {
  const isEverbridgeFlowDesigner = useSelector(isEverbridgeFlowDesignerApp);
  const context = isEverbridgeFlowDesigner ? ebfd : xm;

  return (
    <HelpLinksContext.Provider value={context}>
      {children}
    </HelpLinksContext.Provider>
  );
};
HelpLinksProvider.displayName = 'HelpLinksProvider';

export const useHelpLinks = () => {
  const isEverbridgeFlowDesigner = useSelector(isEverbridgeFlowDesignerApp);
  const context = useContext(HelpLinksContext);
  if (context === undefined) {
    throw new Error('useHelpLinks must be used within HelpLinksProvider');
  }

  // Used when link could be either a URL or a CSHID
  // Returns the URL based on the product type
  const normalizeHelpLink = link => {
    if (!link) {
      return undefined;
    }

    const baseUrl = isEverbridgeFlowDesigner
      ? EBFD_HELP_URL
      : XMATTERS_HELP_URL;
    // Extract the cshid from link if it contains one, otherwise link is a cshid itself
    const cshid = link.includes('cshid') ? link.split('cshid=')[1] : link;

    return `${baseUrl}/#cshid=${cshid}`;
  };

  return {
    helpLinks: context,
    normalizeHelpLink,
  };
};
